import React, { useEffect } from 'react';

import { ApplePayInitParams } from "@payair/apple-pay-sdk/models/ApplePayInitParams"
import { ApplePayButtonParams } from "@payair/apple-pay-sdk/models/ApplePayButtonParams"
import { ApplePayPaymentRequest } from "@payair/apple-pay-sdk/models/ApplePayPaymentRequest"
import { ApplePayPaymentContact } from "@payair/apple-pay-sdk/models/ApplePayPaymentContact";

import PayairEcomWrapperSdk from "@payair/e-com-wrapper-sdk"
import payairApplePay from "@payair/apple-pay-sdk"
import store from '../../store/SrciStore';

const ecomWrapperSdk = PayairEcomWrapperSdk.ecomWrapperSdk
const applePaySdk = payairApplePay.applePaySdk
const ApplePayEventTypeEnums = payairApplePay.ApplePayEventTypeEnums
const ApplePayEventListenerEnums = payairApplePay.ApplePayEventListenerEnums

export default function ApplePayWallet() {

  useEffect(() => {
    window.addEventListener(ApplePayEventListenerEnums.PAYAIR_APPLE_PAY_SDK_LISTENER, event =>
      onApplePayListenerEvent(event)
    )

    initCheckout()
  })

  const onApplePayListenerEvent = (applePayListenerEvent: any) => {
    const applePayEvent = applePayListenerEvent.detail
    console.log("onApplePayListenerEvent:", applePayEvent)

    switch(applePayEvent.eventType){
      case ApplePayEventTypeEnums.SDK_INITIALIZE_SUCCESS:
        renderApplePayButton()
        break;
      default: break;
    }
  }

  const renderApplePayButton = () => {
    const srcApplePayButtonParams = store.getState().applepayInputData.appleInputs.applePayButton
    const applePayButtonParams: ApplePayButtonParams = {
      buttonColor: srcApplePayButtonParams.color,
      buttonType: srcApplePayButtonParams.type
    }
    applePaySdk.renderButton("applePayButton", applePayButtonParams);
  }

  const initCheckout = () => {
    const generalInput = store.getState().srciInputData.generalInput
    const appleInputs = store.getState().applepayInputData.appleInputs
    const billingAddress = store.getState().srciInputData.billingAddress
    const consumer = store.getState().srciInputData.dcfCheckoutParams.consumer

    const shippingMethodOne = {
      label: "shippingMethodOne label",
      detail: "shippingMethodOne detail",
      amount: "15.00",
      identifier: "Test delivery company identifier"
    }

    const shippingMethodTwo = {
      label: "shippingMethodOne label",
      detail: "shippingMethodOne detail",
      amount: "15.00",
      identifier: "Test delivery company identifier"
    }

    const contact: ApplePayPaymentContact = {
      emailAddress: consumer.emailAddress,
      familyName: consumer.firstName,
      givenName: consumer.lastName,
      phoneNumber: "" + consumer.mobileNumber.countryCode + consumer.mobileNumber.phoneNumber,
      phoneticFamilyName: consumer.lastName,
      phoneticGivenName: consumer.lastName,
      addressLines: [billingAddress.line1, billingAddress.line2, billingAddress.line3],
      locality: billingAddress.city,
      subLocality: billingAddress.state,
      administrativeArea: billingAddress.state,
      subAdministrativeArea: billingAddress.state,
      postalCode: billingAddress.zip,
      country: billingAddress.countryCode,
      countryCode: billingAddress.countryCode
    }

    const applePayPaymentRequest: ApplePayPaymentRequest = {
      merchantCapabilities: appleInputs.merchantCapabilities,
      supportedNetworks: appleInputs.supportedNetworks,

      billingContact: contact,
      requiredBillingContactFields: appleInputs.requiredBillingContactFields,
      requiredShippingContactFields: appleInputs.requiredShippingContactFields,
      shippingContact: contact,
      shippingMethods:[shippingMethodOne, shippingMethodTwo],
      shippingType: appleInputs.shippingType,
      shippingContactEditingMode: appleInputs.shippingContactEditingMode,
      supportedCountries: appleInputs.supportedCountries,
      applicationData: appleInputs.applicationData
    }

    const applePayInitParams: ApplePayInitParams  = {
      currencyCode: generalInput.currencyCode,
      totalAmount: generalInput.totalAmount,
      totalAmountLabel: generalInput.totalAmountLabel,
      merchantName: generalInput.merchantName,
      merchantId: generalInput.merchantId,
      pspName: generalInput.pspName,
      transactionId: generalInput.transactionId,
      locale: generalInput.locale,
      applePayPaymentRequest: applePayPaymentRequest
    }

    console.log("applePayInitParams", applePayInitParams)

    ecomWrapperSdk.initSdk(PayairEcomWrapperSdk.EcomWalletSdkEnums.PAYAIR_APPLE_PAY_SDK, applePayInitParams)
  }

  return(
    <>
      <div id="applePayButton" />
    </>
  )
}